/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { Grid, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ko';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CalendarPicker } from '@mui/x-date-pickers';

declare type PickerSelectionState = 'partial' | 'shallow' | 'finish';
declare type PickerOnChangeFn<Dayjs> = (
  date: Dayjs | null,
  selectionState?: PickerSelectionState,
) => void;

interface StaticDatePickerProps {
  date: Dayjs | null;
  onChange: PickerOnChangeFn<Dayjs>;
  shouldDisableDate?: (day: Dayjs) => boolean;
}

export function DatePickerWrapper(props: StaticDatePickerProps) {
  const { date, onChange, shouldDisableDate } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography component="h1" variant="h6" gutterBottom>
          봉사 계획
        </Typography>
        <Typography>
          금요일 저녁과 토요일 오후 시간에 전시대 봉사를 신청할 수 있습니다.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography component="h2" variant="h6" gutterBottom>
          {dayjs(date).locale('ko').format('YYYY-MM-DD (dd)')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}

          <CalendarPicker
            date={date}
            onChange={onChange}
            shouldDisableDate={shouldDisableDate}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
}
